import React from 'react';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import ContactForm from '../../components/ContactForm';
import Footer from '../../components/Footer';
import ContactPressForm from '../../components/ContactPressForm';
import HeroBackground from '../../components/HeroBackground';
import useIntersectionObserver from '../../hooks/useIntersectionObserver';
import styles from './ContactPage.module.scss';
import classNames from 'classnames';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import ContactTravelTradeForm from '../../components/ContactTravelTradeForm/ContactTravelTradeForm';
import LimeHelpdeskForm from '../../components/LimeHelpdeskForm';

const ContactPage = ({ title, preamble, headline, formType, formProps, siteSetting, csrf }) => {
    const { t } = useTranslation();
    const [ref, isVisible] = useIntersectionObserver();

    const rootClasses = classNames(styles['Root'], {
        [styles['Visible']]: isVisible,
    });

    return (
        <div className={rootClasses} ref={ref}>
            <HeroBackground modifiers={['OverflowHidden']} />
            <div className={`${styles['Content']} grid`}>
                <div className={styles['Text']}>
                    <h1 className={styles['Title']}>{title}</h1>
                    <div className={styles['Headline']}>{headline}</div>
                    <div className={styles['Preamble']}>{preamble}</div>
                    {formType === 'media' && <div className={styles['Psa']}>{t('ContactPressForm.psa')}</div>}
                </div>
                <div className={styles['Form']}>
                    <GoogleReCaptchaProvider
                        reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                        scriptProps={{ async: true, defer: true }}>
                        {formType === 'traveltrade' ? (
                            <ContactTravelTradeForm formProps={formProps} csrf={csrf} />
                        ) : formType === 'media' ? (
                            <ContactPressForm formProps={formProps} csrf={csrf} />
                        ) : formType === 'helpdesk' ? (
                            <LimeHelpdeskForm formProps={formProps} csrf={csrf} />
                        ) : (
                            <ContactForm formProps={formProps} csrf={csrf} />
                        )}
                    </GoogleReCaptchaProvider>
                </div>
            </div>
            <div className={styles['FooterWrap']}>
                <div className={`${styles['FooterHr']} grid`} />
                <Footer {...siteSetting?.footer} cookieConsent={siteSetting?.cookieConsent} />
            </div>
        </div>
    );
};

export default basePageWrap(ContactPage, { noBasePageFooter: true });

ContactPage.propTypes = {
    title: PropTypes.string.isRequired,
    preamble: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    formType: PropTypes.string.isRequired,
    formProps: PropTypes.object.isRequired,
    siteSetting: PropTypes.object.isRequired,
    csrf: PropTypes.string.isRequired,
};
